const emailjs = require('emailjs-com');

const sendMail = (e) => {
    e.preventDefault();
    let success = false
    emailjs.sendForm('service_96qggwe', 'template_ybn91ea', e.target, 'user_ktZrU3UAGtDn5HQgigEkj')
        .then((result) => {
            success = true;
            console.log(result.text);
        }, (error) => {
            console.log(error.text);
        });

    if (!success) {
        return false
    }

    return true;
}

export default sendMail;